const nutritionGuidanceSectionTranslations = {
  generalTutorial: "General Tutorial",
  mealTiming: "Meal Timing",
  weightAndMeasurements: "Weight and Measurements",
  kitchenScale: "Kitchen Scale",
  dailyWaterIntake: "Daily Water Intake",
  sleepingHours: "Sleeping Hours",
  recommendedSauces: "Recommended Sauces",
  recommendedSoftDrinks: "Recommended Soft Drinks",
  oil: "Oil",
  actionButton: "View",
};

export default nutritionGuidanceSectionTranslations;
